import { render } from "./webClue.vue?vue&type=template&id=3bac3a69&scoped=true"
import script from "./webClue.vue?vue&type=script&lang=js"
export * from "./webClue.vue?vue&type=script&lang=js"

import "./webClue.vue?vue&type=style&index=0&id=3bac3a69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bac3a69"

export default script